// src/components/InfoDialog.jsx
import React from 'react';
import {
  Dialog, DialogContent, DialogActions, Button, Typography, Box, useTheme
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import PropTypes from 'prop-types';
import { useThemeContext } from '../../Context/ThemeContext';

const InfoDialog = ({
  open,
  title = 'Heads up',
  content,
  onOk,
  okText = 'OK',
  showIcon = true,
  ...props
}) => {
  const { darkMode } = useThemeContext();
  const theme = useTheme();
  const borderBase = 'rgba(79,172,254,0.1)';

  return (
    <Dialog
      open={open}
      onClose={onOk}
      keepMounted
      {...props}
      PaperProps={{
        elevation: 0,
        sx: {
          borderRadius: 1,
          width: 480,
          backgroundColor: darkMode ? '#1e1f22' : '#ffffff',
          border: `1px solid ${borderBase}`,
        },
      }}
      BackdropProps={{
        sx: { backgroundColor: darkMode ? 'rgba(10,14,20,.55)' : 'rgba(10,18,30,.35)' },
      }}
    >
      <DialogContent sx={{ py: 5, px: 4, textAlign: 'center' }}>
        {showIcon && (
          <Box sx={{
            width: 56, height: 56, borderRadius: '50%', mx: 'auto', mb: 1.5,
            display: 'grid', placeItems: 'center',
            background: darkMode ? '#2c2c2e' : '#f7fbff', border: `1px solid ${borderBase}`
          }}>
            <InfoOutlinedIcon sx={{ fontSize: 28, color: theme.palette.primary.main }} />
          </Box>
        )}
        <Typography sx={{ fontSize: '0.9rem', fontWeight: 600, mb: 1 }}>{title}</Typography>
        <Typography sx={{ fontSize: '0.95rem', color: theme.palette.text.secondary }}>
          {content}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
        <Button
          autoFocus
          onClick={onOk}
          variant="contained"
          sx={{ minWidth: 120, textTransform: 'none', fontWeight: 600 }}
        >
          {okText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

InfoDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string,
  content: PropTypes.node.isRequired,
  onOk: PropTypes.func.isRequired,
  okText: PropTypes.string,
  showIcon: PropTypes.bool,
};

export default InfoDialog;
